import { get, post } from "../../utils/axiosInstance";

const BASE_URL = "/rest/inventory/invoice";

export const fetchVendors = () => {
  const url = `/rest/inventory/vendor/`;
  return get(url);
};

export const createInvoice = (data) => {
  const url = `${BASE_URL}/`;
  return post(url, data);
};

export const fetchBoxes = (iId) => {
  const url = `${BASE_URL}/${iId}/boxes`;
  return get(url);
};

export const fetchInvoice = (iId) => {
  const url = `${BASE_URL}/${iId}/`;
  return get(url);
};

export const fetchInvoices = (page, invoiceNumber = null, invoiceDate = null, invoiceVendor = null) => {
  let url = `${BASE_URL}/?page=${page}`;
  if (invoiceNumber) url += `&invoice_number=${invoiceNumber}`;
  if (invoiceDate) url += `&invoice_date=${invoiceDate}`;
  if (invoiceVendor) url += `&vendor=${invoiceVendor}`;
  return get(url);
};
